export default {
  methods: {
    // 查询mo时根据nodeType获取oamTypeCodelist 在MidPanel.vue中使用
    packageMoSearchParams(node) {
      const params = {};
      if (node.nodeType === 'equipment' && node.EquipmentIP.length>1) {
        params.oamTypeCodeArr = node.EquipmentIP.map(equipmentIp => equipmentIp.oamTypeCode);
      } else {
        params.oamTypeCodeArr = Array.of(node.typeCode);
      }
      params.inVersion = node.displaySoftwareVersion;
      return params;
    },
    // 查询分支参数时根据nodeType分别打包参数 在MoTree.vue和OperForm.vue中使用
    packageMoBranchParams(node, mo) {
      const params = {};
      if (node.nodeType === 'equipment') {
        const equipmentIp = node.EquipmentIP.find(equipIp => equipIp.service === mo.rootMoId);
        if (equipmentIp) {
          params.neid = equipmentIp.id;
          params.equipNeVersion = mo.rootMoId;
        } else {
          const equipmentIpId = node.EquipmentIP[0].id;
          params.neid = equipmentIpId;
          params.equipNeVersion = node.displaySoftwareVersion;
        }
      } else {
        params.neid = node.id;
      }
      params.nodeType = node.nodeType;
      params.moName = mo.moName;
      return params;
    },
    packageDangerOperParams(node, mo, mml) {
      const params = {
        cmd: mml,
      };
      if (node.nodeType === 'equipment') {
        const equipmentIp = node.EquipmentIP.find(equipIp => equipIp.service === mo.rootMoId);
        if (equipmentIp) {
          params.equipmentIpId = equipmentIp.id;
        } else {
          const equipmentIpId = node.EquipmentIP[0].id;
          params.equipmentIpId = equipmentIpId;
        }
      } else {
        params.neId = node.id;
      }
      return params;
    },
    // 当nodeType为equipment时，生成MML命令行拼接EquipmentIpId时使用 在OperForm.vue和UadForm.vue中使用
    findEquipmentIpId(node, mo) {
      const equipmentIP = node.EquipmentIP.find(equipIp => equipIp.service === mo.rootMoId);
      if (equipmentIP) {
        return equipmentIP.id;
      }
      return node.EquipmentIP[0].id;
    },
    getUserId() {
      const principal = JSON.parse(sessionStorage.getItem('principal'));
      return principal ? principal.userId : '110';
    },
    getCurrentLocate() {
      // 获取当前语言环境
    }
  }
};